"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagTN = function FlagTN(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.6-58.44A70.62,70.62,0,1,1-58.07,12.18,70.62,70.62,0,0,1,12.6-58.44",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.43,51.75a39.54,39.54,0,1,1,0-79.08,39.09,39.09,0,0,1,20.33,5.68A.87.87,0,0,0,46.84-23,49.12,49.12,0,0,0,12.25-37.22a49.43,49.43,0,1,0,0,98.86A49.1,49.1,0,0,0,46.83,47.43a.87.87,0,0,0-1.08-1.35,39.16,39.16,0,0,1-20.32,5.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.82-15.51,32.73-.69,50.29-6.22a2.48,2.48,0,0,1,2.76,3.81l-10.72,15L53,27.54a2.48,2.48,0,0,1-2.77,3.8L32.7,25.77l-11,14.79a2.48,2.48,0,0,1-4.47-1.46l-.12-18.4L-.3,14.85a2.48,2.48,0,0,1,0-4.71l17.46-5.8.17-18.4a2.48,2.48,0,0,1,4.48-1.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagTN;
exports["default"] = _default;